import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"background-color":"#f5f5f5","overflow":"hidden","padding-top":"0.7rem"} }
const _hoisted_2 = {
  key: 0,
  class: "uploadFilesBox comBox"
}
const _hoisted_3 = {
  key: 2,
  style: {"position":"fixed","left":"0","top":"0px","z-index":"-99"}
}
const _hoisted_4 = ["src"]

import { useRouter } from "vue-router";
import { ref, nextTick } from "vue";
import uploadByPieces from "@/assets/js/uploadNew";
import { ElMessage } from "element-plus";
import uploadData from "./upload_data.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'upload_works',
  setup(__props) {

const router = useRouter();
const percentageValue = ref<number>(0);
const filePath = ref("");
const fileName = ref("");
const loading = ref(false);
const imgs: any = ref("");

const capture = () => {
  nextTick(() => {
    // 获取video和canvas元素
    const video: any = document.getElementById('video3');
    const canvas: any = document.getElementById('myCanvas');
    // console.log(video, canvas)    // 设置canvas尺寸与video一致
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    // 获取canvas的2d绘图上下文
    const context = canvas.getContext('2d');
    // 将当前video帧绘制到canvas上
    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    // 将canvas内容转换为data URL，即Base64编码的图像
    const imageDataUrl = canvas.toDataURL('image/png');
    jpimg.value.push(imageDataUrl);
    console.log(jpimg.value)
  })

}
const allowedExtensions = ref([".mp4", ".mov", ".avi"]);
let im___: any;
const jpimg: any = ref([]);
const handleChange = async (uploadFile: any, uploadFiles: any) => {
  if (
    allowedExtensions.value.indexOf(
      uploadFile.name
        .substring(uploadFile.name.lastIndexOf("."))
        .toLocaleLowerCase()
    ) == -1
  ) {
    ElMessage.warning("格式不正确");
    return;
  }
  loading.value = true;
  const timestamp = Date.now();
  percentageValue.value = 0;
  fileName.value = uploadFile.name;
  imgs.value = await file_base(uploadFile.raw);
  jpimg.value = [];
  clearInterval(im___);
  im___ = setInterval(() => {
    if (jpimg.value.length == 10) {
      clearInterval(im___);
      loading.value = false;
      return
    }
    capture()
  }, 2000);
  uploadByPieces(
    timestamp,
    uploadFile.raw,
    5,
    3,
    (res: any) => {
      percentageValue.value = 100;
      filePath.value = res.data.url;

    },
    (p: any) => {
      percentageValue.value = p;
    },
    (error: any) => {
      console.error(error);
    }
  );
};
const file_base = async (file: any) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

return (_ctx: any,_cache: any) => {
  const _component_upload_filled = _resolveComponent("upload-filled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (percentageValue.value == 0 || percentageValue.value != 100 || jpimg.value.length != 10)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_upload, {
            vclass: "upload-demo",
            drag: "",
            action: "#",
            "auto-upload": false,
            "show-file-list": false,
            "on-change": handleChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
                default: _withCtx(() => [
                  _createVNode(_component_upload_filled)
                ]),
                _: 1
              }),
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "el-upload__text" }, [
                _createElementVNode("div", { class: "uploadFiles_content_1" }, "拖拽视频文件到此处开始上传"),
                _createElementVNode("div", { class: "uploadFiles_content_2" }, " 视频作品仅用于个人展示，不涉及商业用途，请确保作品自己参与，无需商业版权 ")
              ], -1)),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "uploadFiles_content_3" }, "点击选择文件", -1)),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "uploadFiles_content_4" }, " 仅支持MP4/MOV/AVI格式，单个文件大小不超过10G ", -1))
            ]),
            _: 1
          })
        ])), [
          [_directive_loading, loading.value]
        ])
      : (_openBlock(), _createBlock(uploadData, {
          key: 1,
          jpimg: jpimg.value,
          percentageValue: percentageValue.value,
          filePath: filePath.value,
          fileName: fileName.value
        }, null, 8, ["jpimg", "percentageValue", "filePath", "fileName"])),
    (imgs.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("video", {
            src: imgs.value,
            controls: "",
            autoplay: "",
            muted: "",
            id: "video3"
          }, null, 8, _hoisted_4),
          _cache[3] || (_cache[3] = _createElementVNode("canvas", { id: "myCanvas" }, null, -1))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})